
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');
var Template = require('./../../../../skins/newbettingterminal-winabetcameroon.betconstruct.com/terminal/containers/home2/template.js');

import { Component } from "react";
import { HandleLotteryGame } from "../../../helpers/casino/helpers";
import { OpenPopup } from "../../../actions/ui";
import {PropTypes} from 'prop-types';
import { createSelector } from "reselect";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";

class Home2 extends Component {
    constructor (props) {
        super(props);
        this.state = {
            iframeUrl: null
        };
        this.openPopupHandler = this.openPopupHandler.bind(this);
    }

    openPopupHandler (id) {
        return () => {
            this.setState({
                iframeUrl: HandleLotteryGame(this.props.user, id)
            });
            setTimeout(() => this.props.dispatch(OpenPopup("iframe", { iframeUrl: this.state.iframeUrl, id })), 0);

        };
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.user && JSON.stringify(state.user)
        ],
        user => {
            return {
                user: user && JSON.parse(user)
            };
        });
};
Home2.propTypes = {
    user: PropTypes.objectOf(PropTypes.any).isRequired
};

export default connect(mapStateToProps)(UIMixin({ Component: Home2 }));